export const SELECT_1B_3B_FACTOR = 'SELECT_1B_3B_FACTOR';
export const SELECT_1B_3B_BUREAU = 'SELECT_1B_3B_BUREAU';
export const RESET_1B_3B_FACTOR_BUREAU = 'RESET_1B_3B_FACTOR_BUREAU';
